export default "__VITE_ASSET__3d39e3b7__"